<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" label-width="150px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userName" label="用户姓名：">
              {{ formData.userName || "-" }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item prop="invoiceHeader" label="发票抬头：">
              {{ formData.invoiceHeader || "-" }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="invoicePrice" label="开票金额(元)：">
              {{ formData.invoicePrice || "-" }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item prop="invoiceState" label="审核状态：">
              <el-tag v-if="formData.invoiceState == 1">
                {{ stateList.get("1") || "" }}
              </el-tag>
              <el-tag type="success" v-if="formData.invoiceState == 2">
                {{ stateList.get("2") || "" }}
              </el-tag>
              <el-tag type="danger" v-if="formData.invoiceState == 3">
                {{ stateList.get("3") || "" }}
              </el-tag>
            </el-form-item></el-col
          >
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间：">
              {{ formData.ctime || "-" }}
            </el-form-item></el-col
          >
          <el-col :span="12"></el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="申请附件" prop="fileList">
              <div v-if="formData.fileList && $attachmentFiles(formData.fileList).length > 0">
                <el-image
                  v-for="(item, index) of $attachmentFiles(formData.fileList)"
                  :key="index"
                  style="
                    width: 100px;
                    height: 100px;
                    margin-right: 10px;
                    border: 1px solid #eee;
                  "
                  :src="item.filePrefix + item.fileUrl"
                  :preview-src-list="[item.filePrefix + item.fileUrl]"
                >
                </el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="发票附件" prop="invoiceList">
              <div
                v-if="formData.invoiceList && $attachmentFiles(formData.invoiceList).length > 0"
              >
                <div
                  class=""
                  v-for="(item, index) of $attachmentFiles(formData.invoiceList)"
                  :key="index"
                >
                  <a
                    target="_blank"
                    :href="item.filePrefix + item.fileUrl"
                    download
                    >{{ item.fileName || "-" }}</a
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="费用明细" prop="costList">
              <el-table
                size="mini"
                stripe
                border
                v-loading="loading"
                :data="formData.costList"
              >
                <el-table-column
                  min-width="120"
                  show-overflow-tooltip
                  label="油罐"
                  prop="ygId"
                ></el-table-column>
                <el-table-column
                  min-width="120"
                  show-overflow-tooltip
                  label="单价(元)"
                  prop="unitPrice"
                ></el-table-column>
                <el-table-column
                  min-width="120"
                  show-overflow-tooltip
                  label="总价(元)"
                  prop="allPrice"
                ></el-table-column>

                <el-table-column
                  min-width="120"
                  show-overflow-tooltip
                  label="数量"
                  prop="ygNumber"
                ></el-table-column>
                <el-table-column
                  min-width="120"
                  show-overflow-tooltip
                  label="单位"
                  prop="ygUnitName"
                >
                  <template v-slot="{ row }">
                    {{
                      row.costType == "3"
                        ? row.ygUnitName
                        : costTypeUnitList.get(row.costType) || ""
                    }}
                  </template></el-table-column
                >
                <el-table-column
                  min-width="120"
                  show-overflow-tooltip
                  label="费用类型"
                  prop="costType"
                >
                  <template v-slot="{ row }">
                    {{ costTypeList.get(row.costType) || "" }}
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="120"
                  show-overflow-tooltip
                  label="开始计价日期"
                  prop="ygDate"
                ></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label=" ">
              <el-button
                type="primary"
                @click="onExamine"
                v-if="formData.invoiceState == 1"
                >审批</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <ExamineDialog
      :invoiceId="formData.invoiceId"
      :showDialog="showDialog"
      @closeDlg="showDialog = false"
      @successSave="successSave"
      :currentRow="formData"
      v-if="showDialog"
    ></ExamineDialog>
  </div>
</template>

<script>
import { stateList, costTypeList, costTypeUnitList } from '@/utils/dict.js'
import ExamineDialog from '@/views/invoiceManage/examineDialog.vue'

export default {
  name: 'InvoiceManageDetail',
  components: { ExamineDialog },

  data () {
    return {
      formData: {},
      loading: false,
      stateList: stateList,
      costTypeList: costTypeList,
      costTypeUnitList: costTypeUnitList,
      showDialog: false
    }
  },
  created () {
    if (this.invoiceId) {
      this.loadData()
    }
  },
  computed: {
    invoiceId () {
      return this.$route.query.invoiceId
    }
  },
  methods: {
    onExamine (item) {
      this.showDialog = true
    },
    successSave () {
      this.showDialog = false
      this.loadData()
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.invoiceManage.selectYgInvoiceByInvoiceId, {
        params: { invoiceId: this.invoiceId }
      }).then(res => {
        res.costList = res.costList || []
        res.fileList = res.fileList || []
        res.invoiceList = res.invoiceList || []
        this.formData = res || {}
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.form {
  margin-top: 30px;
  width: 100%;
}

.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}
</style>
